import type { Events } from '~/plugins/emitter'

export default function activityPage(data: Events['task-card-event']) {
  return {
    event: data.e,
    task_name: data.data.name,
    task_rewards: data.data.rewards,
    task_id: data.data.id,
  }
}
